import Button from './Button'
import overridden from '../../propValidators/overridden'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class SaveButton extends Component {
  static propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    role: overridden
  }

  render() {
    const { children, role, ...attrs } = this.props

    return (
      <Button role="primary" {...attrs}>
        {children || I18n.t('Save')}
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/buttons/SaveButton.js